// frontend/src/components/FeedbackModal.js

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FeedbackModal.module.css'; 

const FeedbackModal = ({ isOpen, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const [contactPermission, setContactPermission] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (comment.trim() === '') {
        return;
    }
    onSubmit(comment, contactPermission);
    setComment('');
    setContactPermission(false);
  };

  const title = t('feedbackDislikeTitle');
  const placeholder = t('feedbackDislikePlaceholder');

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        <h3>{title}</h3>
        <form onSubmit={handleSubmit}>
          <textarea
            className={styles.infoInput}
            style={{ minHeight: '120px', resize: 'vertical' }}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={placeholder}
            required 
          />
          <div className={styles.themeOptions}>
            <label>
              <input
                type="checkbox"
                id="contactPermission"
                checked={contactPermission}
                onChange={(e) => setContactPermission(e.target.checked)}
              />
              <span></span>
              {t('feedbackContactPermission')}
            </label>
          </div>
          <div className={styles.editControls}>
            <button type="button" onClick={onClose} className={`${styles['button-base']} ${styles['button-neutral']}`}>
              {t('cancel')}
            </button>
            <button type="submit" className={`${styles['button-base']} ${styles['button-primary']}`}>
              {t('sendFeedback')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;